import get from 'lodash.get';

import api from 'lib/api';
import getDocumentTracingObj from 'lib/getDocumentTracingObj';
import { transformWidgetData } from 'lib/transformWidgetData';

import { CARD_FETCH_COMPLETE } from '../liveBlog';

// Types
export const ARTICLE_LOAD_PENDING = 'article/ARTICLE_LOAD_PENDING';
export const ARTICLE_LOAD_COMPLETE = 'article/ARTICLE_LOAD_COMPLETE';
export const ARTICLE_LOAD_FAILED = 'article/ARTICLE_LOAD_FAILED';

// Actions
export const loadArticle = (id) => api({
  endpoint: `article/${id}`,
  types: [ARTICLE_LOAD_PENDING, ARTICLE_LOAD_COMPLETE, ARTICLE_LOAD_FAILED],
});

// Reducer
export const INITIAL_STATE = {
  loading: false,
  content: [],
  error: null,
  isNativeAd: false,
  presentation: {},
};

function buildArticle(data, extensions) {
  const article = data;
  const body = [];

  if (Array.isArray(article.body)) {
    article.body.forEach((item) => {
      try {
        const bodyItem = transformWidgetData(item);

        if (!bodyItem) {
          return;
        }

        body.push(bodyItem);
      } catch (e) {
        // empty
      }
    });
  }

  return {
    ...article,
    body,
    documentTracing: getDocumentTracingObj(article, extensions),
  };
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case ARTICLE_LOAD_PENDING:
      return {
        ...state,
        loading: true,
      };

    case ARTICLE_LOAD_COMPLETE: {
      const { data, extensions } = action.payload;
      const article = data && data.article;

      if (!article) {
        return {
          ...state,
          loading: false,
        };
      }

      return {
        ...state,
        content: [
          buildArticle(article, extensions),
        ],
        loading: false,
        isNativeAd: article.nativeAd,
        presentation: (article && article.presentation) || {},
      };
    }

    case ARTICLE_LOAD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Update article publish date with publish date of most recent card
    case CARD_FETCH_COMPLETE: {
      // Get first item from card search results
      const firstItemPublishDate = get(action, 'payload.data.search.items[0].date.publishedAt', null);
      if (firstItemPublishDate && Array.isArray(state.content) && state.content.length) {
        // Set date value
        const { content } = state;
        if (content[0] && content[0].datePublished) {
          content[0].datePublished = firstItemPublishDate;
          // Update state
          return {
            ...state,
            content,
          };
        }
      }
      // Do not alter state if first item was not found
      return {
        ...state,
      };
    }

    default:
      return state;
  }
}
